module.exports = __webpack_public_path__ + "img/bg19.ba8694bc.jpg";